import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import _, { isFunction } from 'lodash';
import React, {
  useCallback,
  useEffect,
  useState,
  useMemo,
} from 'react';
import { useFormState } from 'react-final-form';
import QCXAutocompleteSelect from '../autocomplete-select/QCXAutocompleteSelect';
import { TIPO_CONHECIMENTO_LIST } from './tipoConhecimentoUtils';

export default function QCXSelectTipoConhecimentoAutocomplete({
  label,
  name,
  configureFilterPredicate,
  ...restProps
}) {
  const { values } = useFormState();

  const [defaultValue, setDefaultValue] = useState('');

  const list = useMemo(() => {
    if (isFunction(configureFilterPredicate)) {
      const filterPredicate = configureFilterPredicate(values);
      const filteredValues = TIPO_CONHECIMENTO_LIST.filter(filterPredicate);

      return filteredValues;
    }

    return TIPO_CONHECIMENTO_LIST;
  }, [
    values,
    configureFilterPredicate,
  ]);

  useEffect(() => {
    const value = list
      .find((item) => (
        item?.value === _.get(values, name)
      ));
    if (value) {
      setDefaultValue(value);
    } else {
      setDefaultValue('');
    }
  }, [values, list]);

  const filterOptions = useMemo(() => (
    createFilterOptions({
      stringify: (option) => (
        option.label + option.value
      ),
    })
  ), []);

  const getOptionLabel = useCallback((item) => (
    item?.label || ''
  ), []);

  const getOptionValue = useCallback((item) => (
    item?.value || ''
  ), []);

  return (
    <QCXAutocompleteSelect
      id={name}
      name={name}
      label={label}
      options={list}
      filterOptions={filterOptions}
      defaultValue={defaultValue}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      {...restProps}
    />
  );
}
